export const commonConstants = {
    GETALL_REQUEST: 'BUILDINGS_GETALL_REQUEST',
    GETALL_SUCCESS: 'BUILDINGS_GETALL_SUCCESS',
    GETALL_FAILURE: 'BUILDINGS_GETALL_FAILURE',

    GET_AVAILABLE_SURVEY_MODULES: 'GET_AVAILABLE_SURVEY_MODULES',
    GET_AVAILABLE_SURVEY_MODULES_LOADING: 'GET_AVAILABLE_SURVEY_MODULES_LOADING',

    CHANGE_SUCCESS: 'BUILDINGS_SELECT_SUCCESS',
    UPDATE_RIGHTS_SUCCESS: 'UPDATE_RIGHTS_SUCCESS',

    CHANGE_APP_SUCCESS: 'CHANGE_APP_SUCCESS',
    GET_CURRENT_VERSION_DATE: 'GET_CURRENT_VERSION_DATE',
    GET_APP_CONFIG: 'GET_APP_CONFIG',

    GETCOUNT_SUCCESS: 'GETCOUNT_SUCCESS',
    GETCOUNT_ERROR: 'GETCOUNT_ERROR',
    GETCOUNT_LOADING: 'GETCOUNT_LOADING',

    CHANGE_MELDINGEN_FILTER_SUCCESS: 'CHANGE_MELDINGEN_FILTER_SUCCESS',

    GET_WORK_ORDERS_COUNTS_LOADING: "GET_WORK_ORDERS_COUNTS_LOADING",
    GET_WORK_ORDERS_COUNTS_ERROR: "GET_WORK_ORDERS_COUNTS_ERROR",
    GET_WORK_ORDERS_COUNTS_SUCCESS: "GET_WORK_ORDERS_COUNTS_SUCCESS",
};

export const LOCAL_STORAGE_GRID_KEYS = {
    REPAIR_REQUEST_COLUMN_VISIBILITY: {
        AFTERCARE: "REPAIR_REQUEST_COLUMN_VISIBILITY",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_REPAIR_REQUEST_COLUMN_VISIBILITY",
        GENERAL: "REPAIR_REQUEST_COLUMN_VISIBILITY",
    },
    REPAIR_REQUEST_DATAGRID_VIEW: {
        AFTERCARE: "AFTERCARE_REPAIR_REQUEST_DATAGRID_VIEW",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_REPAIR_REQUEST_DATAGRID_VIEW",
        GENERAL: "REPAIR_REQUEST_DATAGRID_VIEW",
    },
    REPAIR_REQUEST_COLUMN_SORT: {
        AFTERCARE: "REPAIR_REQUEST_COLUMN_SORT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_REPAIR_REQUEST_COLUMN_SORT",
        GENERAL: "REPAIR_REQUEST_COLUMN_SORT",
    },
    REPAIR_REQUEST_COLUMN_FILTER: {
        AFTERCARE: "REPAIR_REQUEST_COLUMN_FILTER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_REPAIR_REQUEST_COLUMN_FILTER",
        GENERAL: "REPAIR_REQUEST_COLUMN_FILTER",
    },
    REPAIR_REQUEST_COLUMN_ORDER: {
        AFTERCARE: "REPAIR_REQUEST_COLUMN_ORDER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_REPAIR_REQUEST_COLUMN_ORDER",
        GENERAL: "REPAIR_REQUEST_COLUMN_ORDER",
    },
    REPAIR_REQUEST_COLUMN_WIDTH: {
        AFTERCARE: "REPAIR_REQUEST_COLUMN_WIDTH",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_REPAIR_REQUEST_COLUMN_WIDTH",
        GENERAL : "REPAIR_REQUEST_COLUMN_WIDTH",
    },
    REPAIR_REQUEST_PAGINATION: {
        AFTERCARE: "REPAIR_REQUEST_PAGINATION_MODAL",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_REPAIR_REQUEST_PAGINATION",
        GENERAL : "REPAIR_REQUEST_PAGINATION",
    },
    REPAIR_REQUEST_SEARCH_TEXT: {
        AFTERCARE: "REPAIR_REQUEST_SEARCH_TEXT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_REPAIR_REQUEST_SEARCH_TEXT",
        GENERAL : "REPAIR_REQUEST_SEARCH_TEXT",
    },
    DASHBOARD_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_DASHBOARD_COLUMN_VISIBILITY",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_DASHBOARD_COLUMN_VISIBILITY",
        GENERAL: "DASHBOARD_COLUMN_VISIBILITY",
    },
    DASHBOARD_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_DASHBOARD_COLUMN_SORT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_DASHBOARD_COLUMN_SORT",
        GENERAL: "DASHBOARD_COLUMN_SORT",
    },
    DASHBOARD_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_DASHBOARD_COLUMN_FILTER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_DASHBOARD_COLUMN_FILTER",
        GENERAL: "DASHBOARD_COLUMN_FILTER",
    },
    DASHBOARD_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_DASHBOARD_COLUMN_ORDER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_DASHBOARD_COLUMN_ORDER",
        GENERAL: "DASHBOARD_COLUMN_ORDER",
    },
    DASHBOARD_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_DASHBOARD_COLUMN_WIDTH",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_DASHBOARD_COLUMN_WIDTH",
        GENERAL : "DASHBOARD_COLUMN_WIDTH",
    },
    DASHBOARD_PAGINATION: {
        AFTERCARE: "AFTERCARE_DASHBOARD_PAGINATION",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_DASHBOARD_PAGINATION",
        GENERAL : "DASHBOARD_PAGINATION",
    },
    DASHBOARD_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_DASHBOARD_SEARCH_TEXT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_DASHBOARD_SEARCH_TEXT",
        GENERAL : "DASHBOARD_SEARCH_TEXT",
    },
    WORK_ORDERS_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_WORK_ORDERS_COLUMN_VISIBILITY",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_WORK_ORDERS_COLUMN_VISIBILITY",
        RESOLVER:"RESOLVER_WORK_ORDERS_COLUMN_VISIBILITY",
        GENERAL:"WORK_ORDERS_COLUMN_VISIBILITY"
    },
    WORK_ORDERS_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_WORK_ORDERS_COLUMN_SORT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_WORK_ORDERS_COLUMN_SORT",
        RESOLVER:"RESOLVER_WORK_ORDERS_COLUMN_SORT",
        GENERAL:"WORK_ORDERS_COLUMN_SORT"
    },
    WORK_ORDERS_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_WORK_ORDERS_COLUMN_FILTER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_WORK_ORDERS_COLUMN_FILTER",
        RESOLVER:"RESOLVER_WORK_ORDERS_COLUMN_FILTER",
        GENERAL:"WORK_ORDERS_COLUMN_FILTER"
    },
    WORK_ORDERS_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_WORK_ORDERS_COLUMN_ORDER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_WORK_ORDERS_COLUMN_ORDER",
        RESOLVER:"RESOLVER_WORK_ORDERS_COLUMN_ORDER",
        GENERAL:"WORK_ORDERS_COLUMN_ORDER"
    },
    WORK_ORDERS_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_WORK_ORDERS_COLUMN_WIDTH",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_WORK_ORDERS_COLUMN_WIDTH",
        RESOLVER:"RESOLVER_WORK_ORDERS_COLUMN_WIDTH",
        GENERAL:"WORK_ORDERS_COLUMN_WIDTH"
    },
    WORK_ORDERS_PAGINATION: {
        AFTERCARE: "AFTERCARE_WORK_ORDERS_PAGINATION",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_WORK_ORDERS_PAGINATION",
        RESOLVER:"RESOLVER_WORK_ORDERS_PAGINATION",
        GENERAL:"WORK_ORDERS_PAGINATION"
    },
    WORK_ORDERS_DATAGRID_VIEW: {
        AFTERCARE: "AFTERCARE_WORK_ORDERS_DATAGRID_VIEW",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_WORK_ORDERS_DATAGRID_VIEW",
        RESOLVER:"RESOLVER_WORK_ORDERS_DATAGRID_VIEW",
        GENERAL: "WORK_ORDERS_DATAGRID_VIEW",
    },
    WORK_ORDERS_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_WORK_ORDERS_SEARCH_TEXT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_WORK_ORDERS_SEARCH_TEXT",
        RESOLVER:"RESOLVER_WORK_ORDERS_SEARCH_TEXT",
        GENERAL:"WORK_ORDERS_SEARCH_TEXT"
    },
    SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_VISIBILITY",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_VISIBILITY",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_VISIBILITY",
    },
    SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_SORT",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_SORT",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_SORT",
    },
    SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_FILTER",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_FILTER",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_FILTER",
    },
    SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_ORDER",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_ORDER",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_ORDER"
    },
    SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_WIDTH",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_WIDTH",
        GENERAL: "SYSTEM_MAINTENANCE_TASK_AUTOMATION_COLUMN_WIDTH",
    },
    SYSTEM_MAINTENANCE_TASK_AUTOMATION_PAGINATION: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_AUTOMATION_PAGINATION",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_AUTOMATION_PAGINATION",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_AUTOMATION_PAGINATION"
    },
    SYSTEM_MAINTENANCE_TASK_AUTOMATION_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_AUTOMATION_SEARCH_TEXT",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_AUTOMATION_SEARCH_TEXT",
        GENERAL: "SYSTEM_MAINTENANCE_TASK_AUTOMATION_SEARCH_TEXT",
    },
    SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_VISIBILITY",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_VISIBILITY",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_VISIBILITY",
    },
    SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_SORT",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_SORT",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_SORT",
    },
    SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_FILTER",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_FILTER",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_FILTER",
    },
    SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_ORDER",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_ORDER",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_ORDER",
    },
    SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_WIDTH",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_WIDTH",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_HISTORY_COLUMN_WIDTH",
    },
    SYSTEM_MAINTENANCE_TASK_HISTORY_PAGINATION: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_HISTORY_PAGINATION",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_HISTORY_PAGINATION",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_HISTORY_PAGINATION",
    },
    SYSTEM_MAINTENANCE_TASK_HISTORY_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_HISTORY_SEARCH_TEXT",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_HISTORY_SEARCH_TEXT",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_HISTORY_SEARCH_TEXT",
    },
    COMMUNICATION_EVENT_LOGS_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_COMMUNICATION_EVENT_LOGS_COLUMN_VISIBILITY",
        BUYERS_GUIDE: "BUYERS_GUIDE_COMMUNICATION_EVENT_LOGS_COLUMN_VISIBILITY",
        GENERAL : "COMMUNICATION_EVENT_LOGS_COLUMN_VISIBILITY",
    },
    COMMUNICATION_EVENT_LOGS_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_COMMUNICATION_EVENT_LOGS_COLUMN_SORT",
        BUYERS_GUIDE: "BUYERS_GUIDE_COMMUNICATION_EVENT_LOGS_COLUMN_SORT",
        GENERAL : "COMMUNICATION_EVENT_LOGS_COLUMN_SORT",
    },
    COMMUNICATION_EVENT_LOGS_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_COMMUNICATION_EVENT_LOGS_COLUMN_FILTER",
        BUYERS_GUIDE: "BUYERS_GUIDE_COMMUNICATION_EVENT_LOGS_COLUMN_FILTER",
        GENERAL : "COMMUNICATION_EVENT_LOGS_COLUMN_FILTER",
    },
    COMMUNICATION_EVENT_LOGS_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_COMMUNICATION_EVENT_LOGS_COLUMN_ORDER",
        BUYERS_GUIDE: "BUYERS_GUIDE_COMMUNICATION_EVENT_LOGS_COLUMN_ORDER",
        GENERAL : "COMMUNICATION_EVENT_LOGS_COLUMN_ORDER",
    },
    COMMUNICATION_EVENT_LOGS_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_COMMUNICATION_EVENT_LOGS_COLUMN_WIDTH",
        BUYERS_GUIDE: "BUYERS_GUIDE_COMMUNICATION_EVENT_LOGS_COLUMN_WIDTH",
        GENERAL : "COMMUNICATION_EVENT_LOGS_COLUMN_WIDTH",
    },
    COMMUNICATION_EVENT_LOGS_PAGINATION: {
        AFTERCARE: "AFTERCARE_COMMUNICATION_EVENT_LOGS_PAGINATION",
        BUYERS_GUIDE: "BUYERS_GUIDE_COMMUNICATION_EVENT_LOGS_PAGINATION",
        GENERAL : "COMMUNICATION_EVENT_LOGS_PAGINATION",
    },
    COMMUNICATION_EVENT_LOGS_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_COMMUNICATION_EVENT_LOGS_SEARCH_TEXT",
        BUYERS_GUIDE: "BUYERS_GUIDE_COMMUNICATION_EVENT_LOGS_SEARCH_TEXT",
        GENERAL : "COMMUNICATION_EVENT_LOGS_SEARCH_TEXT",
    },
    SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_VISIBILITY",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_VISIBILITY",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_VISIBILITY",
    },
    SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_SORT",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_SORT",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_SORT",
    },
    SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_FILTER",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_FILTER",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_FILTER",
    },
    SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_ORDER",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_ORDER",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_ORDER",
    },
    SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_WIDTH",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_WIDTH",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_COLUMN_WIDTH",
    },
    SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_PAGINATION: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_PAGINATION",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_PAGINATION",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_PAGINATION",
    },
    SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_SEARCH_TEXT",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_SEARCH_TEXT",
        GENERAL : "SYSTEM_MAINTENANCE_TASK_HISTORY_FAILED_SEARCH_TEXT",
    },
    SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_VISIBILITY",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_VISIBILITY",
        GENERAL: "SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_VISIBILITY"
    },
    SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_SORT",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_SORT",
        GENERAL: "SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_SORT"
    },
    SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_FILTER",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_FILTER",
        GENERAL: "SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_FILTER"
    },
    SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_ORDER",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_ORDER",
        GENERAL: "SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_ORDER"
    },
    SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_WIDTH",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_WIDTH",
        GENERAL: "SYSTEM_MAINTENANCE_TEMPLATES_COLUMN_WIDTH"
    },
    SYSTEM_MAINTENANCE_TEMPLATES_PAGINATION: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TEMPLATES_PAGINATION",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TEMPLATES_PAGINATION",
        GENERAL: "SYSTEM_MAINTENANCE_TEMPLATES_PAGINATION"
    },
    SYSTEM_MAINTENANCE_TEMPLATES_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_SYSTEM_MAINTENANCE_TEMPLATES_SEARCH_TEXT",
        BUYERS_GUIDE: "BUYERS_GUIDE_SYSTEM_MAINTENANCE_TEMPLATES_SEARCH_TEXT",
        GENERAL: "SYSTEM_MAINTENANCE_TEMPLATES_SEARCH_TEXT"
    },
    LOGIN_REQUEST_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_LOGIN_REQUEST_COLUMN_VISIBILITY",
        GENERAL: "LOGIN_REQUEST_COLUMN_VISIBILITY",
    },
    LOGIN_REQUEST_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_LOGIN_REQUEST_COLUMN_SORT",
        GENERAL: "LOGIN_REQUEST_COLUMN_SORT"
    },
    LOGIN_REQUEST_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_LOGIN_REQUEST_COLUMN_FILTER",
        GENERAL: "LOGIN_REQUEST_COLUMN_FILTER"
    },
    LOGIN_REQUEST_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_LOGIN_REQUEST_COLUMN_ORDER",
        GENERAL: "LOGIN_REQUEST_COLUMN_ORDER"
    },
    LOGIN_REQUEST_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_LOGIN_REQUEST_COLUMN_WIDTH",
        GENERAL: "LOGIN_REQUEST_COLUMN_WIDTH"
    },
    LOGIN_REQUEST_PAGINATION: {
        AFTERCARE: "AFTERCARE_LOGIN_REQUEST_PAGINATION",
        GENERAL: "LOGIN_REQUEST_PAGINATION"
    },
    LOGIN_REQUEST_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_LOGIN_REQUEST_SEARCH_TEXT",
        GENERAL: "LOGIN_REQUEST_SEARCH_TEXT"
    },
    OBJECT_MODAL_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_OBJECT_MODAL_COLUMN_VISIBILITY",
        GENERAL : "OBJECT_MODAL_COLUMN_VISIBILITY",
    },
    OBJECT_MODAL_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_OBJECT_MODAL_COLUMN_SORT",
        GENERAL: "OBJECT_MODAL_COLUMN_SORT",
    },
    OBJECT_MODAL_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_OBJECT_MODAL_COLUMN_FILTER",
        GENERAL: "OBJECT_MODAL_COLUMN_FILTER",
    },
    OBJECT_MODAL_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_OBJECT_MODAL_COLUMN_ORDER",
        GENERAL: "OBJECT_MODAL_COLUMN_ORDER",
    },
    OBJECT_MODAL_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_OBJECT_MODAL_COLUMN_WIDTH",
        GENERAL: "OBJECT_MODAL_COLUMN_WIDTH",
    },
    OBJECT_MODAL_PAGINATION: {
        AFTERCARE: "AFTERCARE_OBJECT_MODAL_PAGINATION",
        GENERAL: "OBJECT_MODAL_PAGINATION",
    },
    OBJECT_MODAL_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_OBJECT_MODAL_SEARCH_TEXT",
        GENERAL: "OBJECT_MODAL_SEARCH_TEXT",
    },
    SELECT_ORIGINATION_MODAL_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_SELECT_ORIGINATION_MODAL_COLUMN_VISIBILITY",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SELECT_ORIGINATION_MODAL_COLUMN_VISIBILITY",
        GENERAL: "SELECT_ORIGINATION_MODAL_COLUMN_VISIBILITY",
    },
    SELECT_ORIGINATION_MODAL_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_SELECT_ORIGINATION_MODAL_COLUMN_FILTER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SELECT_ORIGINATION_MODAL_COLUMN_FILTER",
        GENERAL: "SELECT_ORIGINATION_MODAL_COLUMN_FILTER",
    },
    SELECT_ORIGINATION_MODAL_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_SELECT_ORIGINATION_MODAL_COLUMN_ORDER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SELECT_ORIGINATION_MODAL_COLUMN_ORDER",
        GENERAL: "SELECT_ORIGINATION_MODAL_COLUMN_ORDER",
    },
    SELECT_ORIGINATION_MODAL_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_SELECT_ORIGINATION_MODAL_COLUMN_WIDTH",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SELECT_ORIGINATION_MODAL_COLUMN_WIDTH",
        GENERAL: "SELECT_ORIGINATION_MODAL_COLUMN_WIDTH",
    },
    SELECT_ORIGINATION_MODAL_PAGINATION: {
        AFTERCARE: "AFTERCARE_SELECT_ORIGINATION_MODAL_PAGINATION",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SELECT_ORIGINATION_MODAL_PAGINATION",
        GENERAL: "SELECT_ORIGINATION_MODAL_PAGINATION",
    },
    SELECT_ORIGINATION_MODAL_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_SELECT_ORIGINATION_MODAL_SEARCH_TEXT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SELECT_ORIGINATION_MODAL_SEARCH_TEXT",
        GENERAL: "SELECT_ORIGINATION_MODAL_SEARCH_TEXT",
    },
    SELECT_RELATION_MODAL_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_SELECT_RELATION_MODAL_COLUMN_VISIBILITY",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SELECT_RELATION_MODAL_COLUMN_VISIBILITY",
        GENERAL: "SELECT_RELATION_MODAL_COLUMN_VISIBILITY",
    },
    SELECT_RELATION_MODAL_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_SELECT_RELATION_MODAL_COLUMN_FILTER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SELECT_RELATION_MODAL_COLUMN_FILTER",
        GENERAL: "SELECT_RELATION_MODAL_COLUMN_FILTER",
    },
    SELECT_RELATION_MODAL_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_SELECT_RELATION_MODAL_COLUMN_ORDER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SELECT_RELATION_MODAL_COLUMN_ORDER",
        GENERAL: "SELECT_RELATION_MODAL_COLUMN_ORDER",
    },
    SELECT_RELATION_MODAL_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_SELECT_RELATION_MODAL_COLUMN_WIDTH",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SELECT_RELATION_MODAL_COLUMN_WIDTH",
        GENERAL: "SELECT_RELATION_MODAL_COLUMN_WIDTH",
    },
    SELECT_RELATION_MODAL_PAGINATION: {
        AFTERCARE: "AFTERCARE_SELECT_RELATION_MODAL_PAGINATION",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SELECT_RELATION_MODAL_PAGINATION",
        GENERAL: "SELECT_RELATION_MODAL_PAGINATION",
    },
    SELECT_RELATION_MODAL_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_SELECT_RELATION_MODAL_SEARCH_TEXT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SELECT_RELATION_MODAL_SEARCH_TEXT",
        GENERAL: "SELECT_RELATION_MODAL_SEARCH_TEXT",
    },
    COMMUNICATION_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_COMMUNICATION_COLUMN_VISIBILITY",
        BUYERS_GUIDE: "BUYERS_GUIDE_COMMUNICATION_COLUMN_VISIBILITY",
        GENERAL: "COMMUNICATION_COLUMN_VISIBILITY",
    },
    COMMUNICATION_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_COMMUNICATION_COLUMN_SORT",
        BUYERS_GUIDE: "BUYERS_GUIDE_COMMUNICATION_COLUMN_SORT",
        GENERAL: "COMMUNICATION_COLUMN_SORT",
    },
    COMMUNICATION_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_COMMUNICATION_COLUMN_FILTER",
        BUYERS_GUIDE: "BUYERS_GUIDE_COMMUNICATION_COLUMN_FILTER",
        GENERAL: "COMMUNICATION_COLUMN_FILTER",
    },
    COMMUNICATION_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_COMMUNICATION_COLUMN_ORDER",
        BUYERS_GUIDE: "BUYERS_GUIDE_COMMUNICATION_COLUMN_ORDER",
        GENERAL: "COMMUNICATION_COLUMN_ORDER",
    },
    COMMUNICATION_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_COMMUNICATION_COLUMN_WIDTH",
        BUYERS_GUIDE: "BUYERS_GUIDE_COMMUNICATION_COLUMN_WIDTH",
        GENERAL: "COMMUNICATION_COLUMN_WIDTH",
    },
    COMMUNICATION_PAGINATION: {
        AFTERCARE: "AFTERCARE_COMMUNICATION_PAGINATION",
        BUYERS_GUIDE: "BUYERS_GUIDE_COMMUNICATION_PAGINATION",
        GENERAL: "COMMUNICATION_PAGINATION",
    },
    COMMUNICATION_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_COMMUNICATION_SEARCH_TEXT",
        BUYERS_GUIDE: "BUYER_GUID_COMMUNICATION_SEARCH_TEXT",
        GENERAL: "COMMUNICATION_SEARCH_TEXT",
    },
    CONTACTS_COMMUNICATION_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_CONTACTS_COMMUNICATION_COLUMN_VISIBILITY",
        BUYERS_GUIDE: "BUYER_GUID_CONTACTS_COMMUNICATION_COLUMN_VISIBILITY",
        GENERAL: "CONTACTS_COMMUNICATION_COLUMN_VISIBILITY",
    },
    CONTACTS_COMMUNICATION_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_CONTACTS_COMMUNICATION_COLUMN_SORT",
        BUYERS_GUIDE: "BUYERS_GUIDE_CONTACTS_COMMUNICATION_COLUMN_SORT",
        GENERAL: "CONTACTS_COMMUNICATION_COLUMN_SORT",
    },
    CONTACTS_COMMUNICATION_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_CONTACTS_COMMUNICATION_COLUMN_FILTER",
        BUYERS_GUIDE: "BUYERS_GUIDE_CONTACTS_COMMUNICATION_COLUMN_FILTER",
        GENERAL: "CONTACTS_COMMUNICATION_COLUMN_FILTER",
    },
    CONTACTS_COMMUNICATION_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_CONTACTS_COMMUNICATION_COLUMN_ORDER",
        BUYERS_GUIDE: "BUYERS_GUIDE_CONTACTS_COMMUNICATION_COLUMN_ORDER",
        GENERAL: "CONTACTS_COMMUNICATION_COLUMN_ORDER",
    },
    CONTACTS_COMMUNICATION_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_CONTACTS_COMMUNICATION_COLUMN_WIDTH",
        BUYERS_GUIDE: "BUYERS_GUIDE_CONTACTS_COMMUNICATION_COLUMN_WIDTH",
        GENERAL: "CONTACTS_COMMUNICATION_COLUMN_WIDTH",
    },
    CONTACTS_COMMUNICATION_PAGINATION: {
        AFTERCARE: "AFTERCARE_CONTACTS_COMMUNICATION_PAGINATION",
        BUYERS_GUIDE: "BUYERS_GUIDE_CONTACTS_COMMUNICATION_PAGINATION",
        GENERAL: "CONTACTS_COMMUNICATION_PAGINATION",
    },
    CONTACTS_COMMUNICATION_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_CONTACTS_COMMUNICATION_SEARCH_TEXT",
        BUYERS_GUIDE: "BUYERS_GUIDE_CONTACTS_COMMUNICATION_SEARCH_TEXT",
        GENERAL: "CONTACTS_COMMUNICATION_SEARCH_TEXT",
    },
    ATTACHMENT_COMMUNICATION_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_ATTACHMENT_COMMUNICATION_COLUMN_VISIBILITY",
        BUYERS_GUIDE: " BUYERS_GUIDE_ATTACHMENT_COMMUNICATION_COLUMN_VISIBILITY",
        GENERAL: "ATTACHMENT_COMMUNICATION_COLUMN_VISIBILITY",
    },
    ATTACHMENT_COMMUNICATION_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_ATTACHMENT_COMMUNICATION_COLUMN_SORT",
        BUYERS_GUIDE: "BUYERS_GUIDE_ATTACHMENT_COMMUNICATION_COLUMN_SORT",
        GENERAL: "ATTACHMENT_COMMUNICATION_COLUMN_SORT",
    },
    ATTACHMENT_COMMUNICATION_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_ATTACHMENT_COMMUNICATION_COLUMN_FILTER",
        BUYERS_GUIDE: "BUYERS_GUIDE_ATTACHMENT_COMMUNICATION_COLUMN_FILTER",
        GENERAL: "ATTACHMENT_COMMUNICATION_COLUMN_FILTER",
    },
    ATTACHMENT_COMMUNICATION_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_ATTACHMENT_COMMUNICATION_COLUMN_ORDER",
        BUYERS_GUIDE: "BUYERS_GUIDE_ATTACHMENT_COMMUNICATION_COLUMN_ORDER",
        GENERAL: "ATTACHMENT_COMMUNICATION_COLUMN_ORDER",
    },
    ATTACHMENT_COMMUNICATION_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_ATTACHMENT_COMMUNICATION_COLUMN_WIDTH",
        BUYERS_GUIDE: "BUYERS_GUIDE_ATTACHMENT_COMMUNICATION_COLUMN_WIDTH",
        GENERAL: "ATTACHMENT_COMMUNICATION_COLUMN_WIDTH",
    },
    ATTACHMENT_COMMUNICATION_PAGINATION: {
        AFTERCARE: "AFTERCARE_ATTACHMENT_COMMUNICATION_PAGINATION",
        BUYERS_GUIDE: "BUYERS_GUIDE_ATTACHMENT_COMMUNICATION_PAGINATION",
        GENERAL: "ATTACHMENT_COMMUNICATION_PAGINATION",
    },
    ATTACHMENT_COMMUNICATION_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_ATTACHMENT_COMMUNICATION_SEARCH_TEXT",
        BUYERS_GUIDE: "BUYERS_GUIDE_ATTACHMENT_COMMUNICATION_SEARCH_TEXT",
        GENERAL: "ATTACHMENT_COMMUNICATION_SEARCH_TEXT",
    },
    QUOTATIONS_COLUMN_VISIBILITY: {
        BUYERS_GUIDE: "BUYERS_GUIDE_QUOTATIONS_COLUMN_VISIBILITY",
        GENERAL: "QUOTATIONS_COLUMN_VISIBILITY"
    },
    QUOTATIONS_COLUMN_SORT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_QUOTATIONS_COLUMN_SORT",
        GENERAL: "QUOTATIONS_COLUMN_SORT"
    },
    QUOTATIONS_COLUMN_FILTER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_QUOTATIONS_COLUMN_FILTER",
        GENERAL: "QUOTATIONS_COLUMN_FILTER"
    },
    QUOTATIONS_COLUMN_ORDER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_QUOTATIONS_COLUMN_ORDER",
        GENERAL: "QUOTATIONS_COLUMN_ORDER"
    },
    QUOTATIONS_COLUMN_WIDTH: {
        BUYERS_GUIDE: "BUYERS_GUIDE_QUOTATIONS_COLUMN_WIDTH",
        GENERAL: "QUOTATIONS_COLUMN_WIDTH"
    },
    QUOTATIONS_PAGINATION: {
        BUYERS_GUIDE: "BUYERS_GUIDE_QUOTATIONS_PAGINATION",
        GENERAL: "QUOTATIONS_PAGINATION"
    },
    QUOTATIONS_SEARCH_TEXT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_QUOTATIONS_SEARCH_TEXT",
        GENERAL: "QUOTATIONS_SEARCH_TEXT"
    },
    CHOSEN_OPTION_COLUMN_VISIBILITY: {
        BUYERS_GUIDE: "BUYERS_GUIDE_CHOSEN_OPTION_COLUMN_VISIBILITY",
        GENERAL: "CHOSEN_OPTION_COLUMN_VISIBILITY"
    },
    CHOSEN_OPTION_COLUMN_SORT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_CHOSEN_OPTION_COLUMN_SORT",
        GENERAL: "CHOSEN_OPTION_COLUMN_SORT"
    },
    CHOSEN_OPTION_COLUMN_FILTER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_CHOSEN_OPTION_COLUMN_FILTER",
        GENERAL: "CHOSEN_OPTION_COLUMN_FILTER"
    },
    CHOSEN_OPTION_COLUMN_ORDER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_CHOSEN_OPTION_COLUMN_ORDER",
        GENERAL: "CHOSEN_OPTION_COLUMN_ORDER"
    },
    CHOSEN_OPTION_COLUMN_WIDTH: {
        BUYERS_GUIDE: "BUYERS_GUIDE_CHOSEN_OPTION_COLUMN_WIDTH",
        GENERAL: "CHOSEN_OPTION_COLUMN_WIDTH"
    },
   CHOSEN_OPTION_PAGINATION: {
        BUYERS_GUIDE: "BUYERS_GUIDE_CHOSEN_OPTION_PAGINATION",
        GENERAL: "CHOSEN_OPTION_PAGINATION"
    },
   CHOSEN_OPTION_SEARCH_TEXT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_CHOSEN_OPTION_SEARCH_TEXT",
        GENERAL: "CHOSEN_OPTION_SEARCH_TEXT"
   },
    QUESTIONNAIRE_TEMPLATE_COLUMN_VISIBILITY: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_QUESTIONNAIRE_TEMPLATE_COLUMN_VISIBILITY",
        GENERAL: "QUESTIONNAIRE_TEMPLATE_COLUMN_VISIBILITY",
    },
    QUESTIONNAIRE_TEMPLATE_COLUMN_SORT: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_QUESTIONNAIRE_TEMPLATE_COLUMN_SORT",
        GENERAL: "QUESTIONNAIRE_TEMPLATE_COLUMN_SORT",
    },
    QUESTIONNAIRE_TEMPLATE_COLUMN_FILTER: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_QUESTIONNAIRE_TEMPLATE_COLUMN_FILTER",
        GENERAL: "QUESTIONNAIRE_TEMPLATE_COLUMN_FILTER",
    },
    QUESTIONNAIRE_TEMPLATE_COLUMN_ORDER: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_QUESTIONNAIRE_TEMPLATE_COLUMN_ORDER",
        GENERAL: "QUESTIONNAIRE_TEMPLATE_COLUMN_ORDER",
    },
    QUESTIONNAIRE_TEMPLATE_COLUMN_WIDTH: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_QUESTIONNAIRE_TEMPLATE_COLUMN_WIDTH",
        GENERAL : "QUESTIONNAIRE_TEMPLATE_COLUMN_WIDTH",
    },
    QUESTIONNAIRE_TEMPLATE_PAGINATION: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_QUESTIONNAIRE_TEMPLATE_PAGINATION",
        GENERAL : "QUESTIONNAIRE_TEMPLATE_PAGINATION",
    },
    QUESTIONNAIRE_TEMPLATE_SEARCH_TEXT: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_QUESTIONNAIRE_TEMPLATE_SEARCH_TEXT",
        GENERAL : "QUESTIONNAIRE_TEMPLATE_SEARCH_TEXT",
    },
    QUESTIONNAIRE_COLUMN_VISIBILITY: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_QUESTIONNAIRE_COLUMN_VISIBILITY",
        GENERAL: "QUESTIONNAIRE_COLUMN_VISIBILITY",
    },
    QUESTIONNAIRE_COLUMN_SORT: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_QUESTIONNAIRE_COLUMN_SORT",
        GENERAL: "QUESTIONNAIRE_COLUMN_SORT",
    },
    QUESTIONNAIRE_COLUMN_FILTER: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_QUESTIONNAIRE_COLUMN_FILTER",
        GENERAL: "QUESTIONNAIRE_COLUMN_FILTER",
    },
    QUESTIONNAIRE_COLUMN_ORDER: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_QUESTIONNAIRE_COLUMN_ORDER",
        GENERAL: "QUESTIONNAIRE_COLUMN_ORDER",
    },
    QUESTIONNAIRE_COLUMN_WIDTH: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_QUESTIONNAIRE_COLUMN_WIDTH",
        GENERAL : "QUESTIONNAIRE_COLUMN_WIDTH",
    },
    QUESTIONNAIRE_PAGINATION: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_QUESTIONNAIRE_PAGINATION",
        GENERAL : "QUESTIONNAIRE_PAGINATION",
    },
    QUESTIONNAIRE_SEARCH_TEXT: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_QUESTIONNAIRE_SEARCH_TEXT",
        GENERAL : "QUESTIONNAIRE_SEARCH_TEXT",
    },
    AGENDA_GENERATION_LIST_COLUMN_VISIBILITY: {
        BUYERS_GUIDE: "BUYERS_GUIDE_AGENDA_GENERATION_LIST_COLUMN_VISIBILITY",
        GENERAL : "AGENDA_GENERATION_LIST_COLUMN_VISIBILITY",
    },
    AGENDA_GENERATION_LIST_COLUMN_SORT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_AGENDA_GENERATION_LIST_COLUMN_SORT",
        GENERAL : "AGENDA_GENERATION_LIST_COLUMN_SORT",
    },
    AGENDA_GENERATION_LIST_COLUMN_FILTER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_AGENDA_GENERATION_LIST_COLUMN_FILTER",
        GENERAL : "AGENDA_GENERATION_LIST_COLUMN_FILTER",
    },
    AGENDA_GENERATION_LIST_COLUMN_ORDER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_AGENDA_GENERATION_LIST_COLUMN_ORDER",
        GENERAL : "AGENDA_GENERATION_LIST_COLUMN_ORDER"
    },
    AGENDA_GENERATION_LIST_COLUMN_WIDTH: {
        BUYERS_GUIDE: "BUYERS_GUIDE_AGENDA_GENERATION_LIST_COLUMN_WIDTH",
        GENERAL: "AGENDA_GENERATION_LIST_COLUMN_WIDTH",
    },
    AGENDA_GENERATION_LIST_PAGINATION: {
        BUYERS_GUIDE: "BUYERS_GUIDE_AGENDA_GENERATION_LIST_PAGINATION",
        GENERAL : "AGENDA_GENERATION_LIST_PAGINATION"
    },
    AGENDA_GENERATION_LIST_SEARCH_TEXT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_AGENDA_GENERATION_LIST_SEARCH_TEXT",
        GENERAL: "AGENDA_GENERATION_LIST_SEARCH_TEXT",
    },
    BUILDING_LIST_FOR_GENERATION_COLUMN_VISIBILITY: {
        BUYERS_GUIDE: "BUYERS_GUIDE_BUILDING_LIST_FOR_GENERATION_COLUMN_VISIBILITY",
        GENERAL : "BUILDING_LIST_FOR_GENERATION_COLUMN_VISIBILITY",
    },
    BUILDING_LIST_FOR_GENERATION_COLUMN_SORT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_BUILDING_LIST_FOR_GENERATION_COLUMN_SORT",
        GENERAL : "BUILDING_LIST_FOR_GENERATION_COLUMN_SORT",
    },
    BUILDING_LIST_FOR_GENERATION_COLUMN_FILTER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_BUILDING_LIST_FOR_GENERATION_COLUMN_FILTER",
        GENERAL : "BUILDING_LIST_FOR_GENERATION_COLUMN_FILTER",
    },
    BUILDING_LIST_FOR_GENERATION_COLUMN_ORDER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_BUILDING_LIST_FOR_GENERATION_COLUMN_ORDER",
        GENERAL : "BUILDING_LIST_FOR_GENERATION_COLUMN_ORDER"
    },
    BUILDING_LIST_FOR_GENERATION_COLUMN_WIDTH: {
        BUYERS_GUIDE: "BUYERS_GUIDE_BUILDING_LIST_FOR_GENERATION_COLUMN_WIDTH",
        GENERAL: "BUILDING_LIST_FOR_GENERATION_COLUMN_WIDTH",
    },
    BUILDING_LIST_FOR_GENERATION_PAGINATION: {
        BUYERS_GUIDE: "BUYERS_GUIDE_BUILDING_LIST_FOR_GENERATION_PAGINATION",
        GENERAL : "BUILDING_LIST_FOR_GENERATION_PAGINATION"
    },
    BUILDING_LIST_FOR_GENERATION_SEARCH_TEXT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_BUILDING_LIST_FOR_GENERATION_SEARCH_TEXT",
        GENERAL: "BUILDING_LIST_FOR_GENERATION_SEARCH_TEXT",
    },
    CONTRACT_OVERVIEW_LIST_COLUMN_VISIBILITY: {
        BUYERS_GUIDE: "BUYERS_GUIDE_CONTRACT_OVERVIEW_LIST_COLUMN_VISIBILITY",
        GENERAL : "CONTRACT_OVERVIEW_LIST_COLUMN_VISIBILITY",
    },
    CONTRACT_OVERVIEW_LIST_COLUMN_SORT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_CONTRACT_OVERVIEW_LIST_COLUMN_SORT",
        GENERAL : "CONTRACT_OVERVIEW_LIST_COLUMN_SORT",
    },
    CONTRACT_OVERVIEW_LIST_COLUMN_FILTER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_CONTRACT_OVERVIEW_LIST_COLUMN_FILTER",
        GENERAL : "CONTRACT_OVERVIEW_LIST_COLUMN_FILTER",
    },
    CONTRACT_OVERVIEW_LIST_COLUMN_ORDER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_CONTRACT_OVERVIEW_LIST_COLUMN_ORDER",
        GENERAL : "CONTRACT_OVERVIEW_LIST_COLUMN_ORDER"
    },
   CONTRACT_OVERVIEW_LIST_COLUMN_WIDTH: {
        BUYERS_GUIDE: "BUYERS_GUIDE_CONTRACT_OVERVIEW_LIST_COLUMN_WIDTH",
        GENERAL: "CONTRACT_OVERVIEW_LIST_COLUMN_WIDTH",
    },
    CONTRACT_OVERVIEW_LIST_PAGINATION: {
        BUYERS_GUIDE: "BUYERS_GUIDE_CONTRACT_OVERVIEW_LIST_PAGINATION",
        GENERAL : "CONTRACT_OVERVIEW_LIST_PAGINATION"
    },
    CONTRACT_OVERVIEW_LIST_SEARCH_TEXT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_CONTRACT_OVERVIEW_LIST_SEARCH_TEXT",
        GENERAL: "CONTRACT_OVERVIEW_LIST_SEARCH_TEXT",
    },
    REPAIR_REQUEST_WORK_ORDERS_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_VISIBILITY",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_REPAIR_REQUEST_WORK_ORDERS_COLUMN_VISIBILITY",
        GENERAL: "REPAIR_REQUEST_WORK_ORDERS_COLUMN_VISIBILITY",
    },
    REPAIR_REQUEST_WORK_ORDERS_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_SORT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_REPAIR_REQUEST_WORK_ORDERS_COLUMN_SORT",
        GENERAL: "REPAIR_REQUEST_WORK_ORDERS_COLUMN_SORT",
    },
    REPAIR_REQUEST_WORK_ORDERS_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_FILTER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_REPAIR_REQUEST_WORK_ORDERS_COLUMN_FILTER",
        GENERAL: "REPAIR_REQUEST_WORK_ORDERS_COLUMN_FILTER",
    },
    REPAIR_REQUEST_WORK_ORDERS_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_ORDER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_REPAIR_REQUEST_WORK_ORDERS_COLUMN_ORDER",
        GENERAL: "REPAIR_REQUEST_WORK_ORDERS_COLUMN_ORDER",
    },
    REPAIR_REQUEST_WORK_ORDERS_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_WIDTH",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_REPAIR_REQUEST_WORK_ORDERS_COLUMN_WIDTH",
        GENERAL : "REPAIR_REQUEST_WORK_ORDERS_COLUMN_WIDTH",
    },
    REPAIR_REQUEST_WORK_ORDERS_PAGINATION: {
        AFTERCARE: "AFTERCARE_REPAIR_REQUEST_WORK_ORDERS_PAGINATION",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_REPAIR_REQUEST_WORK_ORDERS_PAGINATION",
        GENERAL : "REPAIR_REQUEST_WORK_ORDERS_PAGINATION",
    },
    REPAIR_REQUEST_WORK_ORDERS_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_REPAIR_REQUEST_WORK_ORDERS_SEARCH_TEXT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_REPAIR_REQUEST_WORK_ORDERS_SEARCH_TEXT",
        GENERAL : "REPAIR_REQUEST_WORK_ORDERS_SEARCH_TEXT",
    },
    OBJECTS_COLUMN_VISIBILITY: {
        BUYERS_GUIDE: "BUYERS_GUIDE_OBJECTS_COLUMN_VISIBILITY",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_OBJECTS_COLUMN_VISIBILITY",
        GENERAL : "OBJECTS_COLUMN_VISIBILITY",
    },
    OBJECTS_COLUMN_SORT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_OBJECTS_COLUMN_SORT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_OBJECTS_COLUMN_SORT",
        GENERAL : "OBJECTS_COLUMN_SORT",
    },
    OBJECTS_COLUMN_FILTER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_OBJECTS_COLUMN_FILTER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_OBJECTS_COLUMN_FILTER",
        GENERAL : "OBJECTS_COLUMN_FILTER",
    },
    OBJECTS_COLUMN_ORDER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_OBJECTS_COLUMN_ORDER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_OBJECTS_COLUMN_ORDER",
        GENERAL : "OBJECTS_COLUMN_ORDER"
    },
    OBJECTS_COLUMN_WIDTH: {
        BUYERS_GUIDE: "BUYERS_GUIDE_OBJECTS_COLUMN_WIDTH",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_OBJECTS_COLUMN_WIDTH",
        GENERAL: "OBJECTS_COLUMN_WIDTH",
    },
    OBJECTS_PAGINATION: {
        BUYERS_GUIDE: "BUYERS_GUIDE_OBJECTS_PAGINATION",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_OBJECTS_PAGINATION",
        GENERAL : "OBJECTS_PAGINATION"
    },
    OBJECTS_SEARCH_TEXT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_OBJECTS_SEARCH_TEXT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_OBJECTS_SEARCH_TEXT",
        GENERAL: "OBJECTS_SEARCH_TEXT",
    },
    SUB_CONTRACTOR_OVERVIEW_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_SUB_CONTRACTOR_OVERVIEW_COLUMN_VISIBILITY",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SUB_CONTRACTOR_OVERVIEW_COLUMN_VISIBILITY",
        GENERAL: "SUB_CONTRACTOR_OVERVIEW_COLUMN_VISIBILITY",
    },
    SUB_CONTRACTOR_OVERVIEW_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_SUB_CONTRACTOR_OVERVIEW_COLUMN_SORT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SUB_CONTRACTOR_OVERVIEW_COLUMN_SORT",
        GENERAL: "SUB_CONTRACTOR_OVERVIEW_COLUMN_SORT",
    },
    SUB_CONTRACTOR_OVERVIEW_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_SUB_CONTRACTOR_OVERVIEW_COLUMN_FILTER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SUB_CONTRACTOR_OVERVIEW_COLUMN_FILTER",
        GENERAL: "SUB_CONTRACTOR_OVERVIEW_COLUMN_FILTER",
    },
    SUB_CONTRACTOR_OVERVIEW_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_SUB_CONTRACTOR_OVERVIEW_COLUMN_ORDER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SUB_CONTRACTOR_OVERVIEW_COLUMN_ORDER",
        GENERAL: "SUB_CONTRACTOR_OVERVIEW_COLUMN_ORDER",
    },
    SUB_CONTRACTOR_OVERVIEW_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_SUB_CONTRACTOR_OVERVIEW_COLUMN_WIDTH",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SUB_CONTRACTOR_OVERVIEW_COLUMN_WIDTH",
        GENERAL : "SUB_CONTRACTOR_OVERVIEW_COLUMN_WIDTH",
    },
    SUB_CONTRACTOR_OVERVIEW_PAGINATION: {
        AFTERCARE: "AFTERCARE_SUB_CONTRACTOR_OVERVIEW_PAGINATION",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SUB_CONTRACTOR_OVERVIEW_PAGINATION",
        GENERAL : "SUB_CONTRACTOR_OVERVIEW_PAGINATION",
    },
    SUB_CONTRACTOR_OVERVIEW_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_SUB_CONTRACTOR_OVERVIEW_SEARCH_TEXT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SUB_CONTRACTOR_OVERVIEW_SEARCH_TEXT",
        GENERAL : "SUB_CONTRACTOR_OVERVIEW_SEARCH_TEXT",
    },
    WB_EMAIL_LINK_LIST_COLUMN_VISIBILITY: {
        SETTING: "SETTING_WB_EMAIL_LINK_LIST_COLUMN_VISIBILITY",
        GENERAL : "WB_EMAIL_LINK_LIST_COLUMN_VISIBILITY",
    },
    WB_EMAIL_LINK_LIST_COLUMN_SORT: {
        SETTING: "SETTING_WB_EMAIL_LINK_LIST_COLUMN_SORT",
        GENERAL : "WB_EMAIL_LINK_LIST_COLUMN_SORT",
    },
    WB_EMAIL_LINK_LIST_COLUMN_FILTER: {
        SETTING: "SETTING_WB_EMAIL_LINK_LIST_COLUMN_FILTER",
        GENERAL : "WB_EMAIL_LINK_LIST_COLUMN_FILTER",
    },
    WB_EMAIL_LINK_LIST_COLUMN_ORDER: {
        SETTING: "SETTING_WB_EMAIL_LINK_LIST_COLUMN_ORDER",
        GENERAL : "WB_EMAIL_LINK_LIST_COLUMN_ORDER"
    },
    WB_EMAIL_LINK_LIST_COLUMN_WIDTH: {
        SETTING: "SETTING_WB_EMAIL_LINK_LIST_COLUMN_WIDTH",
        GENERAL: "WB_EMAIL_LINK_LIST_COLUMN_WIDTH",
    },
    WB_EMAIL_LINK_LIST_PAGINATION: {
        SETTING: "SETTING_WB_EMAIL_LINK_LIST_PAGINATION",
        GENERAL : "WB_EMAIL_LINK_LIST_PAGINATION"
    },
    WB_EMAIL_LINK_LIST_SEARCH_TEXT: {
        SETTING: "SETTING_WB_EMAIL_LINK_LIST_SEARCH_TEXT",
        GENERAL: " WB_EMAIL_LINK_LIST_SEARCH_TEXT",
    },
    WB_PROJECTS_COLUMN_VISIBILITY: {
        SETTING: "SETTING_WB_PROJECTS_COLUMN_VISIBILITY",
        GENERAL : "WB_PROJECTS_COLUMN_VISIBILITY",
    },
    WB_PROJECTS_COLUMN_SORT: {
        SETTING: "SETTING_WB_PROJECTS_COLUMN_SORT",
        GENERAL : "WB_PROJECTS_COLUMN_SORT",
    },
    WB_PROJECTS_COLUMN_FILTER: {
        SETTING: "SETTING_WB_PROJECTS_COLUMN_FILTER",
        GENERAL : "WB_PROJECTS_COLUMN_FILTER",
    },
    WB_PROJECTS_COLUMN_ORDER: {
        SETTING: "SETTING_WB_PROJECTS_COLUMN_ORDER",
        GENERAL : "WB_PROJECTS_COLUMN_ORDER"
    },
    WB_PROJECTS_COLUMN_WIDTH: {
        SETTING: "SETTING_WB_PROJECTS_COLUMN_WIDTH",
        GENERAL: "WB_PROJECTS_COLUMN_WIDTH",
    },
    WB_PROJECTS_PAGINATION: {
        SETTING: "SETTING_WB_PROJECTS_PAGINATION",
        GENERAL : "WB_PROJECTS_PAGINATION"
    },
    WB_PROJECTS_SEARCH_TEXT: {
        SETTING: "SETTING_WB_PROJECTS_SEARCH_TEXT",
        GENERAL: "WB_PROJECTS_SEARCH_TEXT",
    },
    BUYER_REPAIR_REQUESTS_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_BUYER_REPAIR_REQUESTS_COLUMN_VISIBILITY",
        GENERAL : "BUYER_REPAIR_REQUESTS_COLUMN_VISIBILITY",
    },
    BUYER_REPAIR_REQUESTS_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_BUYER_REPAIR_REQUESTS_COLUMN_SORT",
        GENERAL : "BUYER_REPAIR_REQUESTS_COLUMN_SORT",
    },
    BUYER_REPAIR_REQUESTS_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_BUYER_REPAIR_REQUESTS_COLUMN_FILTER",
        GENERAL : "BUYER_REPAIR_REQUESTS_COLUMN_FILTER",
    },
    BUYER_REPAIR_REQUESTS_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_BUYER_REPAIR_REQUESTS_COLUMN_ORDER",
        GENERAL : "BUYER_REPAIR_REQUESTS_COLUMN_ORDER"
    },
    BUYER_REPAIR_REQUESTS_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_BUYER_REPAIR_REQUESTS_COLUMN_WIDTH",
        GENERAL: "BUYER_REPAIR_REQUESTS_COLUMN_WIDTH",
    },
    BUYER_REPAIR_REQUESTS_PAGINATION: {
        AFTERCARE: "AFTERCARE_BUYER_REPAIR_REQUESTS_PAGINATION",
        GENERAL : "BUYER_REPAIR_REQUESTS_PAGINATION"
    },
    BUYER_REPAIR_REQUESTS_SEARCH_TEXT: {
        AFTERCARE: "BUYERS_GUIDE_BUYER_REPAIR_REQUESTS_SEARCH_TEXT",
        GENERAL: "BUYER_REPAIR_REQUESTS_SEARCH_TEXT",
    },
    CUF_XML_IMPORTS_COLUMN_VISIBILITY: {
     SETTING: "SETTING_CUF_XML_IMPORTS_COLUMN_VISIBILITY",
     GENERAL : "CUF_XML_IMPORTS_COLUMN_VISIBILITY",
    },
    CUF_XML_IMPORTS_COLUMN_SORT: {
        SETTING: "SETTING_CUF_XML_IMPORTS_COLUMN_SORT",
        GENERAL : "CUF_XML_IMPORTS_COLUMN_SORT",
    },
    CUF_XML_IMPORTS_COLUMN_FILTER: {
        SETTING: "SETTING_CUF_XML_IMPORTS_COLUMN_FILTER",
        GENERAL : "CUF_XML_IMPORTS_COLUMN_FILTER",
    },
    CUF_XML_IMPORTS_COLUMN_ORDER: {
        SETTING: "SETTING_CUF_XML_IMPORTS_COLUMN_ORDER",
        GENERAL : "CUF_XML_IMPORTS_COLUMN_ORDER"
    },
    CUF_XML_IMPORTS_COLUMN_WIDTH: {
        SETTING: "SETTING_CUF_XML_IMPORTS_COLUMN_WIDTH",
        GENERAL: "CUF_XML_IMPORTS_COLUMN_WIDTH",
    },
    CUF_XML_IMPORTS_PAGINATION: {
        SETTING: "SETTING_CUF_XML_IMPORTS_PAGINATION",
        GENERAL : "CUF_XML_IMPORTS_PAGINATION"
    },
    CUF_XML_IMPORTS_SEARCH_TEXT: {
        SETTING: "SETTING_CUF_XML_IMPORTS_SEARCH_TEXT",
        GENERAL: "CUF_XML_IMPORTS_SEARCH_TEXT",
    },
    DRAWING_LOCATION_NAMES_COLUMN_VISIBILITY: {
     SETTING: "SETTING_DRAWING_LOCATION_NAMES_COLUMN_VISIBILITY",
     GENERAL : "DRAWING_LOCATION_NAMES_COLUMN_VISIBILITY",
    },
    DRAWING_LOCATION_NAMES_COLUMN_SORT: {
        SETTING: "SETTING_DRAWING_LOCATION_NAMES_COLUMN_SORT",
        GENERAL : "DRAWING_LOCATION_NAMES_COLUMN_SORT",
    },
    DRAWING_LOCATION_NAMES_COLUMN_FILTER: {
        SETTING: "SETTING_DRAWING_LOCATION_NAMES_COLUMN_FILTER",
        GENERAL : "DRAWING_LOCATION_NAMES_COLUMN_FILTER",
    },
    DRAWING_LOCATION_NAMES_COLUMN_ORDER: {
        SETTING: "SETTING_DRAWING_LOCATION_NAMES_COLUMN_ORDER",
        GENERAL : "DRAWING_LOCATION_NAMES_COLUMN_ORDER"
    },
    DRAWING_LOCATION_NAMES_COLUMN_WIDTH: {
        SETTING: "SETTING_DRAWING_LOCATION_NAMES_COLUMN_WIDTH",
        GENERAL: "DRAWING_LOCATION_NAMES_COLUMN_WIDTH",
    },
    DRAWING_LOCATION_NAMES_PAGINATION: {
        SETTING: "SETTING_DRAWING_LOCATION_NAMES_PAGINATION",
        GENERAL : "DRAWING_LOCATION_NAMES_PAGINATION"
    },
    DRAWING_LOCATION_NAMES_SEARCH_TEXT: {
        SETTING: "SETTING_DRAWING_LOCATION_NAMES_SEARCH_TEXT",
        GENERAL: "DRAWING_LOCATION_NAMES_SEARCH_TEXT",
    },
    SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_VISIBILITY: {
     AFTERCARE: "AFTERCARE_SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_VISIBILITY",
     GENERAL : "SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_VISIBILITY",
    },
    SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_SORT",
        GENERAL : "SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_SORT",
    },
    SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_FILTER",
        GENERAL : "SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_FILTER",
    },
    SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_ORDER",
        GENERAL : "SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_ORDER"
    },
    SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_WIDTH",
        GENERAL: "SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_WIDTH",
    },
    SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_PAGINATION: {
        AFTERCARE: "AFTERCARE_SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_PAGINATION",
        GENERAL : "SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_PAGINATION"
    },
    SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_SEARCH_TEXT",
        GENERAL: "SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_SEARCH_TEXT",
    },
    PROJECT_OVERVIEW_COLUMN_VISIBILITY: {
     BUYERS_GUIDE: "BUYERS_GUIDE_PROJECT_OVERVIEW_COLUMN_VISIBILITY",
     GENERAL : "PROJECT_OVERVIEW_COLUMN_VISIBILITY",
    },
    PROJECT_OVERVIEW_COLUMN_SORT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_PROJECT_OVERVIEW_COLUMN_SORT",
        GENERAL : "PROJECT_OVERVIEW_COLUMN_SORT",
    },
    PROJECT_OVERVIEW_COLUMN_FILTER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_PROJECT_OVERVIEW_COLUMN_FILTER",
        GENERAL : "PROJECT_OVERVIEW_COLUMN_FILTER",
    },
    PROJECT_OVERVIEW_COLUMN_ORDER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_PROJECT_OVERVIEW_COLUMN_ORDER",
        GENERAL : "PROJECT_OVERVIEW_COLUMN_ORDER"
    },
    PROJECT_OVERVIEW_COLUMN_WIDTH: {
        BUYERS_GUIDE: "BUYERS_GUIDE_PROJECT_OVERVIEW_COLUMN_WIDTH",
        GENERAL: "PROJECT_OVERVIEW_COLUMN_WIDTH",
    },
    PROJECT_OVERVIEW_PAGINATION: {
        BUYERS_GUIDE: "BUYERS_GUIDE_PROJECT_OVERVIEW_PAGINATION",
        GENERAL : "PROJECT_OVERVIEW_PAGINATION"
    },
    PROJECT_OVERVIEW_SEARCH_TEXT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_PROJECT_OVERVIEW_SEARCH_TEXT",
        GENERAL: "PROJECT_OVERVIEW_SEARCH_TEXT",
    },
    ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_VISIBILITY: {
     AFTERCARE: "AFTERCARE_ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_VISIBILITY",
     CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_VISIBILITY",
     GENERAL : "ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_VISIBILITY",
    },
    ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_SORT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_SORT",
        GENERAL : "ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_SORT",
    },
    ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_FILTER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_FILTER",
        GENERAL : "ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_FILTER",
    },
    ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_ORDER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_ORDER",
        GENERAL : "ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_ORDER"
    },
    ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_WIDTH",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_WIDTH",
        GENERAL: "ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_WIDTH",
    },
    ADD_REPAIR_REQUEST_BUILDINGS_PAGINATION: {
        AFTERCARE: "AFTERCARE_ADD_REPAIR_REQUEST_BUILDINGS_PAGINATION",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ADD_REPAIR_REQUEST_BUILDINGS_PAGINATION",
        GENERAL : "ADD_REPAIR_REQUEST_BUILDINGS_PAGINATION"
    },
    ADD_REPAIR_REQUEST_BUILDINGS_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_ADD_REPAIR_REQUEST_BUILDINGS_SEARCH_TEXT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ADD_REPAIR_REQUEST_BUILDINGS_SEARCH_TEXT",
        GENERAL: "ADD_REPAIR_REQUEST_BUILDINGS_SEARCH_TEXT",
    },
    ADD_REPAIR_REQUEST_PROJECTS_COLUMN_VISIBILITY: {
     CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ADD_REPAIR_REQUEST_PROJECTS_COLUMN_VISIBILITY",
     GENERAL : "ADD_REPAIR_REQUEST_PROJECTS_COLUMN_VISIBILITY",
    },
    ADD_REPAIR_REQUEST_PROJECTS_COLUMN_SORT: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ADD_REPAIR_REQUEST_PROJECTS_COLUMN_SORT",
        GENERAL : "ADD_REPAIR_REQUEST_PROJECTS_COLUMN_SORT",
    },
    ADD_REPAIR_REQUEST_PROJECTS_COLUMN_FILTER: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ADD_REPAIR_REQUEST_PROJECTS_COLUMN_FILTER",
        GENERAL : "ADD_REPAIR_REQUEST_PROJECTS_COLUMN_FILTER",
    },
    ADD_REPAIR_REQUEST_PROJECTS_COLUMN_ORDER: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ADD_REPAIR_REQUEST_PROJECTS_COLUMN_ORDER",
        GENERAL : "ADD_REPAIR_REQUEST_PROJECTS_COLUMN_ORDER"
    },
    ADD_REPAIR_REQUEST_PROJECTS_COLUMN_WIDTH: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ADD_REPAIR_REQUEST_PROJECTS_COLUMN_WIDTH",
        GENERAL: "ADD_REPAIR_REQUEST_PROJECTS_COLUMN_WIDTH",
    },
    ADD_REPAIR_REQUEST_PROJECTS_PAGINATION: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ADD_REPAIR_REQUEST_PROJECTS_PAGINATION",
        GENERAL : "ADD_REPAIR_REQUEST_PROJECTS_PAGINATION"
    },
    ADD_REPAIR_REQUEST_PROJECTS_SEARCH_TEXT: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ADD_REPAIR_REQUEST_PROJECTS_SEARCH_TEXT",
        GENERAL: "ADD_REPAIR_REQUEST_PROJECTS_SEARCH_TEXT",
    },
    SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_VISIBILITY: {
     AFTERCARE: "AFTERCARE_SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_VISIBILITY",
     GENERAL : "SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_VISIBILITY",
    },
    SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_SORT",
        GENERAL : "SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_SORT",
    },
    SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_FILTER",
        GENERAL : "SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_FILTER",
    },
    SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_ORDER",
        GENERAL : "SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_ORDER"
    },
    SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_WIDTH",
        GENERAL: "SECOND_SIGNATURE_REPAIR_REQUESTS_COLUMN_WIDTH",
    },
    SECOND_SIGNATURE_REPAIR_REQUESTS_PAGINATION: {
        AFTERCARE: "AFTERCARE_SECOND_SIGNATURE_REPAIR_REQUESTS_PAGINATION",
        GENERAL : "SECOND_SIGNATURE_REPAIR_REQUESTS_PAGINATION"
    },
    SECOND_SIGNATURE_REPAIR_REQUESTS_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_SECOND_SIGNATURE_REPAIR_REQUESTS_SEARCH_TEXT",
        GENERAL: "SECOND_SIGNATURE_REPAIR_REQUESTS_SEARCH_TEXT",
    },
    SECOND_SIGNATURE_REPAIR_REQUESTS_DATAGRID_VIEW: {
        AFTERCARE: "AFTERCARE_SECOND_SIGNATURE_REPAIR_REQUESTS_DATAGRID_VIEW",
        GENERAL: "SECOND_SIGNATURE_REPAIR_REQUESTS_DATAGRID_VIEW",
    },
    SURVEY_REPAIR_REQUESTS_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_SURVEY_REPAIR_REQUESTS_COLUMN_VISIBILITY",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_REPAIR_REQUESTS_COLUMN_VISIBILITY",
        GENERAL: "SURVEY_REPAIR_REQUESTS_COLUMN_VISIBILITY",
    },
    SURVEY_REPAIR_REQUESTS_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_SURVEY_REPAIR_REQUESTS_COLUMN_SORT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_REPAIR_REQUESTS_COLUMN_SORT",
        GENERAL: "SURVEY_REPAIR_REQUESTS_COLUMN_SORT",
    },
    SURVEY_REPAIR_REQUESTS_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_SURVEY_REPAIR_REQUESTS_COLUMN_FILTER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_REPAIR_REQUESTS_COLUMN_FILTER",
        GENERAL : "SURVEY_REPAIR_REQUESTS_COLUMN_FILTER",
    },
    SURVEY_REPAIR_REQUESTS_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_SURVEY_REPAIR_REQUESTS_COLUMN_ORDER",
        GENERAL : "SURVEY_REPAIR_REQUESTS_COLUMN_ORDER",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_REPAIR_REQUESTS_COLUMN_ORDER",
    },
    SURVEY_REPAIR_REQUESTS_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_SURVEY_REPAIR_REQUESTS_COLUMN_WIDTH",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_REPAIR_REQUESTS_COLUMN_WIDTH",
        GENERAL: "SURVEY_REPAIR_REQUESTS_COLUMN_WIDTH",
    },
    SURVEY_REPAIR_REQUESTS_PAGINATION: {
        AFTERCARE: "AFTERCARE_SURVEY_REPAIR_REQUESTS_PAGINATION",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_REPAIR_REQUESTS_PAGINATION",
        GENERAL : "SURVEY_REPAIR_REQUESTS_PAGINATION",
    },
    SURVEY_REPAIR_REQUESTS_SEARCH_TEXT: {
        AFTERCARE: "AFTERCARE_SURVEY_REPAIR_REQUESTS_SEARCH_TEXT",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_REPAIR_REQUESTS_SEARCH_TEXT",
        GENERAL: "SURVEY_REPAIR_REQUESTS_SEARCH_TEXT",
    },
    SURVEY_REPAIR_REQUESTS_DATAGRID_VIEW: {
        AFTERCARE: "AFTERCARE_SURVEY_REPAIR_REQUESTS_DATAGRID_VIEW",
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_REPAIR_REQUESTS_DATAGRID_VIEW",
        GENERAL: "SURVEY_REPAIR_REQUESTS_DATAGRID_VIEW",
    },
    SURVEY_MOMENTS_COLUMN_VISIBILITY: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_MOMENTS_COLUMN_VISIBILITY",
        GENERAL:"SURVEY_MOMENTS_COLUMN_VISIBILITY"
    },
    SURVEY_MOMENTS_COLUMN_SORT: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_MOMENTS_COLUMN_SORT",
        GENERAL:"SURVEY_MOMENTS_COLUMN_SORT"
    },
    SURVEY_MOMENTS_COLUMN_FILTER: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_MOMENTS_COLUMN_FILTER",
        GENERAL:"SURVEY_MOMENTS_COLUMN_FILTER"
    },
    SURVEY_MOMENTS_COLUMN_ORDER: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_MOMENTS_COLUMN_ORDER",
        GENERAL:"SURVEY_MOMENTS_COLUMN_ORDER"
    },
    SURVEY_MOMENTS_COLUMN_WIDTH: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_MOMENTS_COLUMN_WIDTH",
        GENERAL:"SURVEY_MOMENTS_COLUMN_WIDTH"
    },
    SURVEY_MOMENTS_PAGINATION: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_MOMENTS_PAGINATION",
        GENERAL:"SURVEY_MOMENTS_PAGINATION"
    },
    SURVEY_MOMENTS_SEARCH_TEXT: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_MOMENTS_SEARCH_TEXT",
        GENERAL:"SURVEY_MOMENTS_SEARCH_TEXT"
    },
    SURVEY_MOMENTS_DATAGRID_VIEW: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_SURVEY_MOMENTS_DATAGRID_VIEW",
        GENERAL: "SURVEY_MOMENTS_DATAGRID_VIEW",
    },
    ASSIGNMENTS_COLUMN_VISIBILITY: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ASSIGNMENTS_COLUMN_VISIBILITY",
        GENERAL:"ASSIGNMENTS_COLUMN_VISIBILITY"
    },
    ASSIGNMENTS_COLUMN_SORT: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ASSIGNMENTS_COLUMN_SORT",
        GENERAL:"ASSIGNMENTS_COLUMN_SORT"
    },
    ASSIGNMENTS_COLUMN_FILTER: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ASSIGNMENTS_COLUMN_FILTER",
        GENERAL:"ASSIGNMENTS_COLUMN_FILTER"
    },
    ASSIGNMENTS_COLUMN_ORDER: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ASSIGNMENTS_COLUMN_ORDER",
        GENERAL:"ASSIGNMENTS_COLUMN_ORDER"
    },
    ASSIGNMENTS_COLUMN_WIDTH: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ASSIGNMENTS_COLUMN_WIDTH",
        GENERAL:"ASSIGNMENTS_COLUMN_WIDTH"
    },
    ASSIGNMENTS_PAGINATION: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ASSIGNMENTS_PAGINATION",
        GENERAL:"ASSIGNMENTS_PAGINATION"
    },
    ASSIGNMENTS_SEARCH_TEXT: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ASSIGNMENTS_SEARCH_TEXT",
        GENERAL:"ASSIGNMENTS_SEARCH_TEXT"
    },
    ASSIGNMENTS_DATAGRID_VIEW: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_ASSIGNMENTS_DATAGRID_VIEW",
        GENERAL: "ASSIGNMENTS_DATAGRID_VIEW",
    },
    STANDARD_OPTIONS_COLUMN_VISIBILITY: {
        BUYERS_GUIDE: "BUYERS_GUIDE_STANDARD_OPTIONS_COLUMN_VISIBILITY",
        GENERAL: "STANDARD_OPTIONS_COLUMN_VISIBILITY",
    },
    STANDARD_OPTIONS_COLUMN_SORT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_STANDARD_OPTIONS_COLUMN_SORT",
        GENERAL: "STANDARD_OPTIONS_COLUMN_SORT",
    },
    STANDARD_OPTIONS_COLUMN_FILTER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_STANDARD_OPTIONS_COLUMN_FILTER",
        GENERAL: "STANDARD_OPTIONS_COLUMN_FILTER",
    },
    STANDARD_OPTIONS_COLUMN_ORDER: {
        BUYERS_GUIDE: "BUYERS_GUIDE_STANDARD_OPTIONS_COLUMN_ORDER",
        GENERAL: "STANDARD_OPTIONS_COLUMN_ORDER"
    },
    STANDARD_OPTIONS_COLUMN_WIDTH: {
        BUYERS_GUIDE: "BUYERS_GUIDE_STANDARD_OPTIONS_COLUMN_WIDTH",
        GENERAL: "STANDARD_OPTIONS_COLUMN_WIDTH",
    },
    STANDARD_OPTIONS_PAGINATION: {
        BUYERS_GUIDE: "BUYERS_GUIDE_STANDARD_OPTIONS_PAGINATION",
        GENERAL: "STANDARD_OPTIONS_PAGINATION"
    },
    STANDARD_OPTIONS_SEARCH_TEXT: {
        BUYERS_GUIDE: "BUYERS_GUIDE_STANDARD_OPTIONS_SEARCH_TEXT",
        GENERAL: "STANDARD_OPTIONS_SEARCH_TEXT",
    },
    BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_VISIBILITY: {
        AFTERCARE: "AFTERCARE_BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_VISIBILITY",
        GENERAL: "BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_VISIBILITY",
    },
    BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_SORT: {
        AFTERCARE: "AFTERCARE_BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_SORT",
        GENERAL: "BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_SORT",
    },
    BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_FILTER: {
        AFTERCARE: "AFTERCARE_BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_FILTER",
        GENERAL: "BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_FILTER",
    },
    BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_ORDER: {
        AFTERCARE: "AFTERCARE_BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_ORDER",
        GENERAL: "BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_ORDER"
    },
    BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_WIDTH: {
        AFTERCARE: "AFTERCARE_BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_WIDTH",
        GENERAL: "BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_WIDTH",
    },
    BUYER_REPAIR_REQUEST_RESOLVERS_PAGINATION: {
        AFTERCARE: "AFTERCARE_BUYER_REPAIR_REQUEST_RESOLVERS_PAGINATION",
        GENERAL: "BUYER_REPAIR_REQUEST_RESOLVERS_PAGINATION"
    },
    BUYER_REPAIR_REQUEST_RESOLVERS_SEARCH_TEXT: {
        AFTERCARE: "BUYERS_GUIDE_BUYER_REPAIR_REQUEST_RESOLVERS_SEARCH_TEXT",
        GENERAL: "BUYER_REPAIR_REQUEST_RESOLVERS_SEARCH_TEXT",
    },
    EXISTING_REPAIR_REQUEST_FILES_COLUMN_VISIBILITY: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_EXISTING_REPAIR_REQUEST_FILES_COLUMN_VISIBILITY",
        GENERAL:"EXISTING_REPAIR_REQUEST_FILES_COLUMN_VISIBILITY"
    },
    EXISTING_REPAIR_REQUEST_FILES_COLUMN_SORT: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_EXISTING_REPAIR_REQUEST_FILES_COLUMN_SORT",
        GENERAL:"EXISTING_REPAIR_REQUEST_FILES_COLUMN_SORT"
    },
    EXISTING_REPAIR_REQUEST_FILES_COLUMN_FILTER: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_EXISTING_REPAIR_REQUEST_FILES_COLUMN_FILTER",
        GENERAL:"EXISTING_REPAIR_REQUEST_FILES_COLUMN_FILTER"
    },
    EXISTING_REPAIR_REQUEST_FILES_COLUMN_ORDER: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_EXISTING_REPAIR_REQUEST_FILES_COLUMN_ORDER",
        GENERAL:"EXISTING_REPAIR_REQUEST_FILES_COLUMN_ORDER"
    },
    EXISTING_REPAIR_REQUEST_FILES_COLUMN_WIDTH: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_EXISTING_REPAIR_REQUEST_FILES_COLUMN_WIDTH",
        GENERAL:"EXISTING_REPAIR_REQUEST_FILES_COLUMN_WIDTH"
    },
    EXISTING_REPAIR_REQUEST_FILES_PAGINATION: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_EXISTING_REPAIR_REQUEST_FILES_PAGINATION",
        GENERAL:"EXISTING_REPAIR_REQUEST_FILES_PAGINATION"
    },
    EXISTING_REPAIR_REQUEST_FILES_SEARCH_TEXT: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_EXISTING_REPAIR_REQUEST_FILES_SEARCH_TEXT",
        GENERAL:"EXISTING_REPAIR_REQUEST_FILES_SEARCH_TEXT"
    },
    EXISTING_WKB_REPAIR_REQUEST_FILES_COLUMN_VISIBILITY: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_EXISTING_WKB_REPAIR_REQUEST_FILES_COLUMN_VISIBILITY",
        GENERAL:"EXISTING_WKB_REPAIR_REQUEST_FILES_COLUMN_VISIBILITY"
    },
    EXISTING_WKB_REPAIR_REQUEST_FILES_COLUMN_SORT: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_EXISTING_WKB_REPAIR_REQUEST_FILES_COLUMN_SORT",
        GENERAL:"EXISTING_WKB_REPAIR_REQUEST_FILES_COLUMN_SORT"
    },
    EXISTING_WKB_REPAIR_REQUEST_FILES_COLUMN_FILTER: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_EXISTING_WKB_REPAIR_REQUEST_FILES_COLUMN_FILTER",
        GENERAL:"EXISTING_WKB_REPAIR_REQUEST_FILES_COLUMN_FILTER"
    },
    EXISTING_WKB_REPAIR_REQUEST_FILES_COLUMN_ORDER: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_EXISTING_WKB_REPAIR_REQUEST_FILES_COLUMN_ORDER",
        GENERAL:"EXISTING_WKB_REPAIR_REQUEST_FILES_COLUMN_ORDER"
    },
    EXISTING_WKB_REPAIR_REQUEST_FILES_COLUMN_WIDTH: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_EXISTING_WKB_REPAIR_REQUEST_FILES_COLUMN_WIDTH",
        GENERAL:"EXISTING_WKB_REPAIR_REQUEST_FILES_COLUMN_WIDTH"
    },
    EXISTING_WKB_REPAIR_REQUEST_FILES_PAGINATION: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_EXISTING_WKB_REPAIR_REQUEST_FILES_PAGINATION",
        GENERAL:"EXISTING_WKB_REPAIR_REQUEST_FILES_PAGINATION"
    },
    EXISTING_WKB_REPAIR_REQUEST_FILES_SEARCH_TEXT: {
        CONSTRUCTION_QUALITY: "CONSTRUCTION_QUALITY_EXISTING_WKB_REPAIR_REQUEST_FILES_SEARCH_TEXT",
        GENERAL:"EXISTING_WKB_REPAIR_REQUEST_FILES_SEARCH_TEXT"
    },
    STANDARD_TEXT_MANAGER_COLUMN_VISIBILITY: {
        GENERAL: "STANDARD_TEXT_MANAGER_COLUMN_VISIBILITY",
    },
    STANDARD_TEXT_MANAGER_COLUMN_SORT: {
        GENERAL: "STANDARD_TEXT_MANAGER_COLUMN_SORT",
    },
    STANDARD_TEXT_MANAGER_COLUMN_FILTER: {
        GENERAL: "STANDARD_TEXT_MANAGER_COLUMN_FILTER",
    },
    STANDARD_TEXT_MANAGER_COLUMN_ORDER: {
        GENERAL: "STANDARD_TEXT_MANAGER_COLUMN_ORDER"
    },
    STANDARD_TEXT_MANAGER_COLUMN_WIDTH: {
        GENERAL: "STANDARD_TEXT_MANAGER_COLUMN_WIDTH",
    },
    STANDARD_TEXT_MANAGER_PAGINATION: {
        GENERAL: "STANDARD_TEXT_MANAGER_PAGINATION"
    },
    STANDARD_TEXT_MANAGER_SEARCH_TEXT: {
        GENERAL: "STANDARD_TEXT_MANAGER_SEARCH_TEXT",
    },
};